import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";

const EditPreparationCategory = ({ show, onClose, id, onUpdated }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const [categoryName, setCategoryName] = useState("");
  const [items, setItems] = useState([]); // Array of all active items
  const [selectedItems, setSelectedItems] = useState(new Set()); // Use Set for faster lookup
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && id) {
      setLoading(true);
      axios
        .get(`${baseURL}/preparation-category/${id}`)
        .then((res) => {
          const data = res.data?.data;
          if (data) {
            setCategoryName(data.preparationcategory_name || "");
            // Initialize selectedItems as a Set of item.sno from category items (using item_id)
            const selected = new Set(data.items.map((item) => item.item_id));
            setSelectedItems(selected);
          }
        })
        .catch((err) => console.error("Error fetching category:", err))
        .finally(() => setLoading(false));
    }
  }, [show, id, baseURL]);

  useEffect(() => {
    if (show) {
      setLoading(true);
      axios
        .get(`${baseURL}/manage-items/active`)
        .then((res) => {
          if (res.data?.data) {
            setItems(res.data.data);
          }
        })
        .catch((err) => console.error("Error fetching items:", err))
        .finally(() => setLoading(false));
    }
  }, [show, baseURL]);

  const toggleItemSelection = (itemSno) => {
    setSelectedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemSno)) {
        newSet.delete(itemSno);
      } else {
        newSet.add(itemSno);
      }
      return newSet;
    });
  };

  const handleUpdate = () => {
    if (!categoryName.trim()) {
      alert("Preparation Category name is required.");
      return;
    }
    if (selectedItems.size === 0) {
      alert("Please select at least one item.");
      return;
    }

    const payload = {
      preparationcategory_name: categoryName,
      items: Array.from(selectedItems),
      updated_by: 1, // adjust as needed
    };

    axios
      .post(`${baseURL}/preparation-category/${id}`, payload)
      .then((res) => {
        if (res.data.success) {
          // alert("Preparation category updated successfully!");
          toast.success("Preparation category updated successfully!");
          if (onUpdated) onUpdated(res.data.data);
          onClose();
        } else {
          toast.error("Preparation category Updation Failed");
          // alert("Failed to update preparation category.");
        }
      })
      .catch((error) => {
        console.error("Error updating preparation category:", error);
        alert("An error occurred while updating.");
      });
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: "#3ab384" }}>
          <h3 className="modal-title text-white">Update Preparation Category</h3>
          <Button variant="" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Preparation Category <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Preparation Category"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                disabled={loading}
              />
            </div>
          </div>

          <div className="row mt-2">
            <label className="text-red font-w500 fs-6 mb-3">Select Items</label>
            <div className="scroll-y mh-350px py-2">
              <div className="row">
                {items.length === 0 && <p>Loading items...</p>}
                {items.map((item) => (
                  <div
                    key={item.sno}
                    className="col-lg-6 mb-2 d-flex align-items-center"
                  >
                    <input
                      className="form-check-input me-3"
                      type="checkbox"
                      id={`item-${item.sno}`}
                      value={item.sno}
                      checked={selectedItems.has(item.sno)}
                      onChange={() => toggleItemSelection(item.sno)}
                      disabled={loading}
                    />
                    <label
                      className="fs-7 text-black font-w500 mt-1"
                      htmlFor={`item-${item.sno}`}
                    >
                      {item.item_name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
            <Button
              className="btn btn-sm btn-primary"
              onClick={handleUpdate}
              disabled={loading}
            >
              Update Preparation Category
              <i className="fas fa-angle-double-right ms-2"></i>
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditPreparationCategory;
